import React from 'react';
import { useTranslation } from 'react-i18next';
import Review from './Review';

export default function Reviews(props) {
    let { products } = props;

    const { t } = useTranslation();

    return (
        <div className="reviews px-4">
            {0 === products.length ?
                (<p>{t("reviews.p_1")}</p>) :
                (products.map((product, index) => <Review product={product} key={index} />))}
        </div>
    );
}
